import React, { useState } from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Link,
  Checkbox,
  Divider,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';

/**
 * Component to display a checklist of items to verify during a call
 * Identical to the original CallChecklist with the same items
 */
const NewKBCallChecklist = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const headingColor = useColorModeValue('blue.600', 'blue.200');
  const linkColor = useColorModeValue('blue.500', 'blue.300');

  // Using the same exact checklist items from the original component
  const [checked, setChecked] = useState({});
  
  const checklistItems = [
    'Is this your wedding? (If yes, congratulate them!)',
    'Introduction to Sumaroh Wedding',
    'Date of Wedding',
    'Preferred Cities',
    'Flow of Events (Functions, Timelines)',
    'Category of Venues (5 star, 4 star, resort Banquet, etc.)',
    'Guest Count for Each Function',
    'Menu Preferences (Veg or Non Veg)',
    'Alcohol at the Wedding? (Yes/No, Type of Service)',
    'Services Required (e.g., Planning, Décor, Photography, Entertainment, etc.)',
    'Stay for Guests? (Yes/No)',
    'If Stay: Number of Rooms Required',
    'Budget discussion'
  ];

  const toggleChecked = (index) => {
    setChecked(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <Box 
      p={2} 
      borderRadius="md" 
      borderWidth="1px" 
      borderColor={borderColor}
      bg={bgColor}
      height="100%"
      overflowY="auto"
    >
      <VStack align="start" spacing={1} width="100%">
        <Heading size="sm" color={headingColor} mb={0}>Call Checklist</Heading>
        
        <Link 
          href="https://www.notion.so/Lead-Sales-Initial-Call-SOP-Sumaaroh-English-translate-to-Hinglish-625b11a1146446948cdfdcea09fba822?pvs=4" 
          isExternal
          color={linkColor}
          fontWeight="medium"
          display="flex"
          alignItems="center"
          fontSize="sm"
          mb={0}
        >
          Call script <Icon as={FaExternalLinkAlt} ml={1} fontSize="xs" />
        </Link>

        <Divider my={1} />

        <VStack align="start" spacing={0} width="100%">
          {checklistItems.map((item, index) => (
            <Checkbox 
              key={index} 
              colorScheme="blue" 
              size="sm" 
              my={0.5}
              isChecked={checked[index] || false}
              onChange={() => toggleChecked(index)}
            >
              <Text fontSize="sm" lineHeight="short">{item}</Text>
            </Checkbox>
          ))}
        </VStack>
      </VStack>
    </Box>
  );
};

export default NewKBCallChecklist;
